export default {
    events: [],
    weekPlan: [],
    order:null,
    reservations:[],
    open_reservation:[]
  };
  